import Image from "next/image";
import i18n from "i18n";

type Experience = {
  id: number;
  company: string;
  position: string;
  url: { link_type: string; url: string; target: string };
  start_date: string;
  end_date?: string;
  logo: { alt?: string; copyright?: string; dimension: { width: number; height: number }; url: string };
};

export default function Timeline({ experiences }: { experiences: Experience[] }) {
  return (
    <div className="flow-root">
      <ul className="-mb-8">
        {experiences.map(item => (
          <li key={`${item.company}_${item.position}`}>
            <div className="relative pb-8">
              <div className="relative flex space-x-3">
                <div className="relative h-10 w-10 rounded-full flex items-center justify-center shadow-md">
                  <Image
                    className="rounded-full"
                    src={item.logo.url}
                    alt={item.company}
                    objectFit="cover"
                    layout="fill"
                  />
                </div>
                <div className="min-w-0 max-w-xl flex-1 flex flex-col md:flex-row justify-between md:space-x-4">
                  <div className="flex flex-col justify-center">
                    <p className="font-medium text-sm text-gray-900">{item.position}</p>
                    <p className="text-sm text-gray-500">
                      <a href={item.url.url} rel="nofollow noreferrer" target="_blank">
                        {item.company}
                      </a>
                    </p>
                  </div>

                  <div className="text-left md:text-right text-sm whitespace-nowrap text-gray-500 space-x-2">
                    <time dateTime={item.start_date}>
                      {new Intl.DateTimeFormat("en-US", {
                        year:
                          item.end_date &&
                          new Date(item.end_date).getFullYear() === new Date(item.start_date).getFullYear()
                            ? undefined
                            : "numeric",
                        month: "long",
                        day: "numeric",
                      }).format(new Date(item.start_date))}
                    </time>
                    <span>&mdash;</span>
                    {item.end_date && (
                      <time dateTime={item.end_date}>
                        {new Intl.DateTimeFormat("en-US", {
                          year: "numeric",
                          month: "long",
                        }).format(new Date(item.end_date))}
                      </time>
                    )}
                    {!item.end_date && <span>{i18n.t("Current")}</span>}
                  </div>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
